"use strict";

function isNumberKeyCode(keyCode) {
    return (keyCode > 95 && keyCode < 106) || // keypad numbers
        (keyCode > 47 && keyCode < 58); // 0 to 9
}

function isDecimalMarkKeyCode(keyCode) {
    return (keyCode === 190) || // period
        (keyCode === 188) || // comma
        (keyCode === 110); // decimal point
}

function isCommonFormInputKeyCode(keyCode) {
    return (keyCode === 8) || // backspace
        (keyCode === 9) || // tab
        (keyCode === 13) || // enter
        (keyCode >= 37 && keyCode <= 40) // key left/up/right/down
}

function bindKeyDown(e) {
    var keyCode = e.keyCode;
    return (isNumberKeyCode(keyCode) ||
        isDecimalMarkKeyCode(keyCode) ||
        isCommonFormInputKeyCode(keyCode)) && !e.shiftKey;
}

angular.module("core")
.directive("positivenumber", function() {
    return {
        require: 'ngModel',
        link: function(scope, element) {
            element.bind("keydown", bindKeyDown);
        }
    }
})
.directive("positiveinteger", function() {
    return function(scope, element, attrs) {
        element.bind("keydown", function(e) {
            var keyCode = e.keyCode;
            return isNumberKeyCode(keyCode) ||
                isCommonFormInputKeyCode(keyCode);
        });
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/positive-number/positive-number.directive.js
// module id = 485
// module chunks = 0